import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Wyoming Holding</p>
        <h1>Your Trusted Management Partner</h1>
        <p className="lede">
          At Wyoming Holding, we provide comprehensive management solutions tailored to meet your needs. 
          Explore our services and discover how we can help you achieve your goals.
        </p>
        <div className="cta-row">
          <a href="#services" target="_self">
            Explore Our Services
          </a>
          <a href="#contact" target="_self" className="secondary">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Streamlined Solutions</h2>
          <p>
            Our expert team is dedicated to delivering efficient management strategies that drive success 
            and growth for your business.
          </p>
        </article>
        <article>
          <h2>Tailored Strategies</h2>
          <p>
            We understand that every business is unique. Our customized approaches ensure that we meet 
            your specific needs and objectives.
          </p>
        </article>
        <article>
          <h2>Ongoing Support</h2>
          <p>
            With Wyoming Holding, you gain a partner committed to your long-term success, providing 
            continuous support and guidance every step of the way.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;